<div>
  <finxone-select-dropdown
    [optionLabelKey]="'label'"
    [optionValueKey]="'value'"
    [appendToBody]="true"
    [label]="dataIn?.attri?.widgetProperties['inputLabel'] ?? 'Currency'"
    [options]="currencyListOptions"
    [selectedOption]="selectedOption?.label ?? ''"
    [searchEnabled]="true"
    (selectionChange)="onCurrencyChange($event)"
  >
  </finxone-select-dropdown>
</div>
